export default class Group {
  id: string;
  name: string;
  description: string;
  company: string;

  constructor({
                id = "",
                name = "",
                description = "",
                company = "",
              } = {}) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.company = company;
  }
}